import ClipboardJS from 'clipboard'
function initApp() {
  var clipboard = new ClipboardJS('.btn-clipboard');
}
document.addEventListener('DOMContentLoaded', initApp);
